import { ThreadListItemPrimitive, useAuiState } from '@assistant-ui/react';
import cx from 'clsx';

import classes from './ThreadList.module.css';
import { ThreadListItemArchive } from './ThreadListItemArchive.tsx';

/** Renders a single chat thread in the thread list with title display and archive functionality. */
export function ThreadListItem() {
  const isMainThread = useAuiState(({ threads, threadListItem }) => threads.mainThreadId === threadListItem.id);
  return (
    <ThreadListItemPrimitive.Root className={cx(classes.threadListItem, isMainThread && classes.mainThread)}>
      <ThreadListItemPrimitive.Trigger className={classes.threadListItemTrigger}>
        <ThreadListItemPrimitive.Title fallback="New Chat" />
      </ThreadListItemPrimitive.Trigger>
      <ThreadListItemArchive />
    </ThreadListItemPrimitive.Root>
  );
}
